import { Space } from '@tribeplatform/gql-client/types'
import { Form } from '@tribeplatform/react-sdk/components'
import { useDeleteSpace } from '@tribeplatform/react-sdk/hooks'
import { Button } from '@tribeplatform/react-ui-kit/Button'
import { FormControl } from '@tribeplatform/react-ui-kit/FormControl'
import { toast } from '@tribeplatform/react-ui-kit/Toast'

export const SpaceSettingsDelete = ({
  space,
  onClose,
}: {
  space: Space
  onClose: () => void
}) => {
  const { mutateAsync: deleteSpace, isLoading } = useDeleteSpace()

  return (
    <>
      <Form
        onSubmit={async (data, methods) => {
          const { name } = data
          const { setError } = methods
          if (name !== space?.name) {
            setError('name', {
              message: 'The space name is incorrect.',
              type: 'validate',
            })
            return
          }
          try {
            await deleteSpace({
              id: space?.id,
            })
            toast({
              title: 'Space deleted',
              status: 'success',
            })
            onClose()
          } catch (e) {
            toast({
              title: 'Unable to delete space',
              status: 'error',
            })
          }
        }}
      >
        <div className="col-span-12 md:col-span-8 flex flex-col space-y-5">
          <h2>Danger Zone</h2>
          <div>
            <FormControl.Label>Delete {space?.name}</FormControl.Label>
            <FormControl.HelperText>
              You will lose posts, comments and all content related to the
              space.
            </FormControl.HelperText>
          </div>
          <Form.Input
            name="name"
            label="Enter the name of the space to confirm"
          />

          <Form.Actions>
            <Button type="submit" loading={isLoading} variant="danger">
              Delete
            </Button>
          </Form.Actions>
        </div>
      </Form>
    </>
  )
}
